import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconLock: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.18182 6H2.72727V3.5C2.72727 1.84315 4.19252 0.5 6 0.5C7.80748 0.5 9.27273 1.84315 9.27273 3.5V6H9.81818C11.0226 6.00121 11.9987 6.89593 12 8V13.5C11.9987 14.6041 11.0226 15.4988 9.81818 15.5H2.18182C0.977379 15.4988 0.00131512 14.6041 0 13.5V8C0.00131512 6.89593 0.977379 6.00121 2.18182 6ZM3.81818 6H8.18182V3.5C8.18182 2.39543 7.20498 1.5 6 1.5C4.79502 1.5 3.81818 2.39543 3.81818 3.5V6Z"
        fill="#868E92"
      />
    </svg>
  </IconStyled>
);

IconLock.defaultProps = iconDefaultProps;
IconLock.displayName = 'IconLock';

export default IconLock;
